<template>
    <div class="text-center" id="import-categories">
        <h6 v-if="sheets.length" class="mb-3 mt-3">{{$t('message.importCategories')}}</h6>
        <div style="width: 90%; margin: 0 auto;">
            <div class="form-group">
                <select @change="getCategories" v-model="currentSheet" v-if="sheets.length" name="" id=""
                        class="form-control">
                    <option value="" disabled selected>{{$t('message.selectProject')}}</option>
                    <option v-for="(sheet, index) in sheets" :key="index" :value="sheet.id">{{sheet.project.name}}
                    </option>
                </select>
            </div>
            <div class="col-md-12" style="font-size: 0.85em">
                <div class="row text-center">
                    <div style="width: 100%" v-if="!sheets.length">
                        <h6>{{$t('message.noCategoriesToImport')}}</h6>
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-2">
                        <table v-if="categories.personnel.length" style="word-break: break-all" class="table table-striped">
                            <tr>
                                <th>{{$t('message.personnel')}}</th>
                                <th><span @click="addAllOneType('personnel')"><i
                                        class="fa fa-plus add-all-one-type"></i></span></th>
                            </tr>
                            <tr v-for="(category, index) in categories.personnel" :key="index">
                                <td>{{category.name}}, {{category.value}}</td>
                                <td class="text-center"><span @click="addCategory(category)"><i
                                        class="fa fa-plus-circle add-category-btn"></i></span></td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-2">
                        <table v-if="categories.material.length" style="word-break: break-all" class="table table-striped">
                            <tr>
                                <th>{{$t('message.material')}}</th>
                                <th><span @click="addAllOneType('material')"><i class="fa fa-plus add-all-one-type"></i></span>
                                </th>
                            </tr>
                            <tr v-for="(category, index) in categories.material" :key="index">
                                <td>{{category.name}}, {{category.value}}</td>
                                <td class="text-center"><span @click="addCategory(category)"><i
                                        class="fa fa-plus-circle add-category-btn"></i></span></td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-2">
                        <table v-if="categories['foreign power'].length"  style="word-break: break-all" class="table table-striped">
                            <tr>
                                <th>{{$t('message.foreignService')}}</th>
                                <th><span @click="addAllOneType('foreign power')"><i
                                        class="fa fa-plus add-all-one-type"></i></span></th>
                            </tr>
                            <tr v-for="(category, index) in categories['foreign power']" :key="index">
                                <td>{{category.name}}, {{category.value}}</td>
                                <td class="text-center"><span @click="addCategory(category)"><i
                                        class="fa fa-plus-circle add-category-btn"></i></span></td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-2">
                        <table v-if="categories.inventory.length"  style="word-break: break-all" class="table table-striped">
                            <tr>
                                <th>{{$t('message.inventory')}}</th>
                                <th><span @click="addAllOneType('inventory')"><i
                                        class="fa fa-plus add-all-one-type"></i></span></th>
                            </tr>
                            <tr v-for="(category, index) in categories.inventory" :key="index">
                                <td>{{category.name}}, {{category.value}}</td>
                                <td class="text-center"><span @click="addCategory(category)"><i
                                        class="fa fa-plus-circle add-category-btn"></i></span></td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-2">
                        <table v-if="categories['additional costs'].length"  style="word-break: break-all" class="table table-striped">
                            <tr>
                                <th>{{$t('message.additionalCosts')}}</th>
                                <th><span @click="addAllOneType('additional costs')"><i
                                        class="fa fa-plus add-all-one-type"></i></span></th>
                            </tr>
                            <tr v-for="(category, index) in categories['additional costs']" :key="index">
                                <td>{{category.name}}, {{category.value}}</td>
                                <td class="text-center"><span @click="addCategory(category)"><i
                                        class="fa fa-plus-circle add-category-btn"></i></span></td>
                            </tr>
                        </table>
                    </div>
                </div>
                <hr v-if="checkIfAnyAdded">
                <!--  ********************************SELECTED CATEGORIES***************************** -->
                <h6 v-if="checkIfAnyAdded" class="mb-3">{{$t('message.selectedCategories')}}</h6>
                <div class="row mb-3 text-center">
                    <div class="col-md-1"></div>
                    <div class="col-md-2 categories-column-table">
                        <table v-if="addedCategories.personnel.length" style="word-break: break-all" class="table table-striped">
                            <tr>
                                <th>{{$t('message.personnel')}}</th>
                                <th><span><i @click="removeAllOneType('personnel')"
                                             class="fa fa-minus remove-all-one-type"></i></span></th>
                            </tr>
                            <tr v-for="(category, index) in addedCategories.personnel" :key="index">
                                <td>{{category.name}}, {{category.value}}</td>
                                <td class="text-center"><span @click="removeCategory(category)"><i
                                        class="fa fa-minus-circle remove-category-btn"></i></span></td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-2 categories-column-table">
                        <table v-if="addedCategories.material.length" style="word-break: break-all" class="table table-striped">
                            <tr>
                                <th>{{$t('message.material')}}</th>
                                <th><span><i @click="removeAllOneType('material')"
                                             class="fa fa-minus remove-all-one-type"></i></span></th>
                            </tr>
                            <tr v-for="(category, index) in addedCategories.material" :key="index">
                                <td>{{category.name}}, {{category.value}}</td>
                                <td class="text-center"><span @click="removeCategory(category)"><i
                                        class="fa fa-minus-circle remove-category-btn"></i></span></td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-2 categories-column-table">
                        <table v-if="addedCategories['foreign power'].length" style="word-break: break-all" class="table table-striped">
                            <tr>
                                <th>{{$t('message.foreignService')}}</th>
                                <th><span><i @click="removeAllOneType('foreign power')"
                                             class="fa fa-minus remove-all-one-type"></i></span></th>
                            </tr>
                            <tr v-for="(category, index) in addedCategories['foreign power']" :key="index">
                                <td>{{category.name}}, {{category.value}}</td>
                                <td class="text-center"><span @click="removeCategory(category)"><i
                                        class="fa fa-minus-circle remove-category-btn"></i></span></td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-2 categories-column-table">
                        <table v-if="addedCategories.inventory.length" style="word-break: break-all" class="table table-striped">
                            <tr>
                                <th>{{$t('message.inventory')}}</th>
                                <th><span><i @click="removeAllOneType('inventory')"
                                             class="fa fa-minus remove-all-one-type"></i></span></th>
                            </tr>
                            <tr v-for="(category, index) in addedCategories.inventory" :key="index">
                                <td>{{category.name}}, {{category.value}}</td>
                                <td class="text-center"><span @click="removeCategory(category)"><i
                                        class="fa fa-minus-circle remove-category-btn"></i></span></td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-2 categories-column-table">
                        <table v-if="addedCategories['additional costs'].length" style="word-break: break-all" class="table table-striped">
                            <tr>
                                <th>{{$t('message.additionalCosts')}}</th>
                                <th><span><i @click="removeAllOneType('additional costs')"
                                             class="fa fa-minus remove-all-one-type"></i></span></th>
                            </tr>
                            <tr v-for="(category, index) in addedCategories['additional costs']" :key="index">
                                <td>{{category.name}}, {{category.value}}</td>
                                <td class="text-center"><span @click="removeCategory(category)"><i
                                        class="fa fa-minus-circle remove-category-btn"></i></span></td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="mb-3 mt-2" v-if="checkIfAnyAdded">
                    <hr>
                    <button @click="importCategories" class="btn btn-primary">{{$t('message.import')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'ImportCategories',
    data () {
      return {
        sheets: [],
        categories: {
          'personnel': [],
          'material': [],
          'foreign power': [],
          'inventory': [],
          'additional costs': []
        },
        defaultCategories: {
          'personnel': [],
          'material': [],
          'foreign power': [],
          'inventory': [],
          'additional costs': []
        },
        addedCategories: {
          'personnel': [],
          'material': [],
          'foreign power': [],
          'inventory': [],
          'additional costs': []
        },
        currentSheet: ''
      }
    },
    props: ['sheetId', 'userId'],
    created () {
      this.getList(this.apiPrefix, this.sheetApiUrl + `?user_id=${this.userId}`)
        .then(resp => {
          this.sheets = resp.data.filter(sheet => sheet.id !== this.sheetId)

          if (this.sheets.length) {
            this.getCategories()
          }
        }).catch(err => {
        console.log(err.response)
      })
    },
    methods: {
      getCategories () {
        this.categories = JSON.parse(JSON.stringify(this.defaultCategories))
        if (this.currentSheet !== '') {
          this.getList(this.apiPrefix, this.categoriesApiUrl, `?sheet__id=${this.currentSheet}`)
            .then(resp => {
              for (const cat of resp.data) {
                this.sortCategoriesData(cat)
              }
            })
            .catch(err => {
              console.log(err.response)
            })
        }
      },
      addCategory (category) {
        if (this.findByProperty(this.addedCategories[category.type], 'id', category.id) === -1) {
          this.addedCategories[category.type].push(category)
        }
      },
      removeCategory (category) {
        this.addedCategories[category.type] = this.addedCategories[category.type].filter(row => row.id !== category.id)
      },
      addAllOneType (type) {
        this.addedCategories[type] = this.categories[type]
      },
      removeAllOneType (type) {
        this.addedCategories[type] = []
      },
      importCategories(){
        this.$emit('importCategories', this.addedCategories);
        this.$emit('close');
      }
    },
    computed: {
      checkIfAnyAdded () {
        return this.addedCategories['personnel'].length || this.addedCategories['material'].length || this.addedCategories['foreign power'].length || this.addedCategories['inventory'].length || this.addedCategories['additional costs'].length
      },
    }
  }
</script>

<style scoped>
    table {
        margin-bottom: 0;
    }

    table td {
        padding: 1px;
        vertical-align: middle;
    }

    .add-category-btn {
        color: #0a568c;
        font-size: 1.1em;
        cursor: pointer;
    }

    .remove-category-btn {
        color: #d9534f;
        font-size: 1.1em;
        cursor: pointer;
    }

    .add-all-one-type {
        cursor: pointer;
    }

    .remove-all-one-type {
        color: #d9534f;
        cursor: pointer;
    }

    .categories-column-table{
        display: table;
    }

</style>